import { useSelector } from "react-redux";
import { useTripLoadingDetails, type LoadingStep } from "@apac/hooks";
import { FlightSearchSelectors } from "@b2bportal/core-flights";
import { LoadingScreen } from "@hsbc/portal";

interface LoadingScreenProps {
  loadingSteps: Array<LoadingStep>;
  isLoading: boolean;
  showCancelButton?: boolean;
  showFlightSearchDetails?: boolean;
}

export const CartLoadingScreen: React.FC<LoadingScreenProps> = ({
  isLoading,
  loadingSteps,
}) => {
  const passengerCounts = useSelector(
    FlightSearchSelectors.passengerCountSelector
  );

  const flightLoadingDetails = useTripLoadingDetails({
    passengerCounts,
  });

  if (!isLoading) {
    return null;
  }

  return (
    <LoadingScreen
      loadingSteps={loadingSteps}
      isLoading={isLoading}
      flightLoadingDetails={flightLoadingDetails}
    />
  );
};
